import { MessageSquareIcon } from "lucide-react";

type FloatingChatButtonProps = {
  onClick: () => void;
};

export function FloatingChatButton({ onClick }: FloatingChatButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="analysis-assistant-open-button"
      className="fixed bottom-8 right-8 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-violet-600 text-white shadow-2xl transition-all hover:bg-violet-700 hover:scale-105 active:scale-95 animate-in fade-in-0 slide-in-from-bottom-4 duration-300"
      aria-label="Open Analysis Assistant"
      title="Ask anything about this analysis"
    >
      <MessageSquareIcon
        className="h-7 w-7"
        style={{ pointerEvents: "none" }}
      />
    </button>
  );
}
